import {
  FETCH_CITY,
  FETCH_CITY_SUCCESS,
  FETCH_CITY_FAIL,
  GET_CITY,
  GET_CITY_SUCCESS,
  GET_CITY_FAIL,
  CREATE_CITY,
  CREATE_CITY_SUCCESS,
  CREATE_CITY_FAIL,
  UPDATE_CITY,
  UPDATE_CITY_SUCCESS,
  UPDATE_CITY_FAIL,
  DELETE_CITY,
  DELETE_CITY_SUCCESS,
  DELETE_CITY_FAIL,
} from 'actions/address';
import * as _ from 'lodash';
import { toast } from 'react-toastify';

const initialState = {
  isLoading: false,
  city: [],
  cityDetail: {},
  page: 1,
  limit: 10,
  totalPages: 1,
  total: 1,
};

const cityReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_CITY:
    case GET_CITY:
    case CREATE_CITY:
    case DELETE_CITY: {
      return { ...state, isLoading: true, cityDetail: {} };
    }

    case UPDATE_CITY: {
      return { ...state, isLoading: true };
    }

    case FETCH_CITY_SUCCESS: {
      if (payload.page === 1) {
        return {
          ...state,
          isLoading: false,
          city: payload.results,
          page: payload.page,
          limit: payload.limit,
          totalPages: payload.totalPages,
          total: payload.totalResults,
        };
      } else {
        return {
          ...state,
          isLoading: false,
          city: _.concat(state.city, payload.results),
          page: payload.page,
          limit: payload.limit,
          totalPages: payload.totalPages,
          total: payload.totalResults,
        };
      }
    }

    case GET_CITY_SUCCESS: {
      return {
        ...state,
        cityDetail: payload,
        isLoading: false,
      };
    }

    case CREATE_CITY_SUCCESS: {
      toast.success('City added successfully');
      return {
        ...state,
        city: _.concat(state.city, payload),
        isLoading: false,
      };
    }

    case UPDATE_CITY_SUCCESS: {
      toast.success('City updated successfully');
      return {
        ...state,
        isLoading: false,
        city: state.city.map((data) => (data.id === payload.id ? payload : data)),
      };
    }

    case DELETE_CITY_SUCCESS: {
      toast.success('City deleted successfully');
      return {
        ...state,
        isLoading: false,
        city: state.city.filter((data) => data.id !== payload),
      };
    }

    case FETCH_CITY_FAIL:
    case GET_CITY_FAIL:
    case CREATE_CITY_FAIL:
    case UPDATE_CITY_FAIL:
    case DELETE_CITY_FAIL: {
      return { ...state, isLoading: false };
    }

    default:
      return { ...state };
  }
};
export default cityReducer;
